//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import JobCard from '~/components/Card/JobCard';

export default {
  name: 'JobList',
  props: {
    jobList: { type: Array, default: () => {} },
    total: { type: Number, default: 0 },
    pagerInfo: { type: Object, default: () => {} },
  },
  components: {
    JobCard,
  },
  data() {
    return {
      sortOptions: [
        {
          value: 'seniority_min',
          label: '薪資',
        },
        {
          value: 'create_time',
          label: '刊登時間',
        },
      ],
      sort: '',
    };
  },
  head() {
    return {
      title: 'STEP1NE 職缺博覽會 - 探索最新職位機會',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: '發掘STEP1NE職缺博覽會的最新職位',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '瀏覽STEP1NE的職缺博覽會，發現各行各業的最新職位機會。無論您是尋求職業發展或換工作，我們提供豐富的選擇以滿足您的需求。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            '瀏覽STEP1NE的職缺博覽會，發現各行各業的最新職位機會。無論您是尋求職業發展或換工作，我們提供豐富的選擇以滿足您的需求。',
        },
      ],
    };
  },
  computed: {
    showPager() {
      if (this.pagerInfo.size > this.pagerInfo.total) return false;
      return true;
    },
  },
  methods: {
    onChangeSort(value) {
      const payload = {
        orderField: value,
        orderSort: 'ASC',
      };
      this.$emit('sortChange', payload);
    },
    handleCurrentChange(current) {
      this.$parent.conditions = {
        ...this.$parent.conditions,
        ...this.pagerInfo,
        current,
      };
    },
  },
};
